import { ISiteSectionEntry } from '@move-frontend/contentful';
import Header from './Header';
import { getParentLink } from '../../../utils/getParentLink';
import { useCommonData } from '../../../common-data/useCommonData';
import { IPageEntry } from '../../../contentful/types/IPage';
import { getContentfulBackgroundImage } from '../../../utils/getContentfulBackgroundImage';
import { getContentfulBackgroundVideo } from '../../../utils/getContentfulBackgroundVideo';

interface IPageHeader {
	page: IPageEntry;
	titleTop: boolean;
	siteSection?: ISiteSectionEntry;
}

export default function PageHeader({
	page,
	titleTop,
	siteSection,
}: IPageHeader) {
	const { pathToPageIdMap } = useCommonData();
	const { background, backgroundPosition } = page.fields;

	const headerImage = background && getContentfulBackgroundImage(background);

	const video = background && getContentfulBackgroundVideo(background);

	const title = page?.fields.title;

	const parentLink = page ? getParentLink(page, pathToPageIdMap) : '';

	// TO DO: https://moveagency.atlassian.net/browse/CVGA-240
	const backLink = (parentLink !== undefined && parentLink) || '/';

	return (
		<Header
			backgroundPosition={backgroundPosition}
			backgroundImage={headerImage}
			backgroundVideo={video?.url}
			backgroundVideoFormat={video?.contentType}
			title={title}
			backLink={page.fields.isLandingPage ? undefined : backLink}
			titleTop={titleTop}
			siteSection={siteSection}
		/>
	);
}
